module.exports = __webpack_public_path__ + "static/img/icon_charging.23a2b388.png";